export const defaultFontSize = "14px";

// Font family
// Use custom Roboto font name to avoid text flashing issue due to third party import.
export const fontRoboto = 'Font Roboto, "Roboto fallback", sans-serif';
export const fontRobotoCondensed = "Roboto Condensed,Roboto Condensed fallback, sans-serif";
export const fontMerriweather = 'Merriweather, "Merriweather fallback", serif';
export const fontBarlow = "Barlow, sans-serif";
export const fontBarlowCondensed = "Barlow Condensed, Roboto Condensed, Roboto Condensed fallback, sans-serif";
export const fontBarlowSemiCondensed = "Barlow Semi Condensed, Roboto Condensed,Roboto Condensed fallback";
export const fontPlayfairDisplay = "Playfair Display, serif";
export const fontAngkor = "Angkor, verdana";
export const fontFredoka = "Fredoka, sans-serif";
export const fontHeebo = "Heebo, sans-serif";